import React from 'react';
import { Link } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';

function CallToAction({
  title,
  description,
  linkTo = '/contact',
  linkLabel = 'Contact me',
}) {
  return (
    <div className="cta-container">
      <h2>{title}</h2>
      <p>{description}</p>
      <ScrollToTop />
      <div className="nav menu-links-compact cta-links">
        <Link className="nav-link" to={linkTo}>
          {linkLabel}
        </Link>
      </div>
    </div>
  );
}

export default CallToAction;
